/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState, useMemo } from "react";
import {
  IconDownload,
  IconPlus,
  IconAdjustmentsHorizontal,
  IconRefresh,
  IconSearch,
  IconX,
  IconChevronLeft,
  IconChevronRight,
  IconUpload,
  IconRotateClockwise,
} from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ButtonStyled from "../../../components/common/ButtonStyled";
import DropdownFilter from "../../../components/common/DropdownFilter";
import OrderSummaryStats from "./OrderSummaryStats";
import AllOrderTable from "./AllOrderTable";
import FilterSidebar from "./FilterSidebar";
import Tooltip from "../../../components/common/Tooltip";
import AddOrdersModals from "./AddOrdersModals";
import EditOrderModal from "./EditOrderModal";
import SmsModal from "./SmsModal";
import DeleteModal from "./DeleteModal";
import Forword3PlModal from "./Forword3PlModal";
import ReverseOrderWiseModal from "./ReverseOrderWiseModal";
import LabelPrintModal from "./LabelPrintModal";
import PremiumSearch from "../../../components/common/PremiumSearch";
import { useNavigate } from "react-router-dom";
import {
  useFetchDeleteOrdersData,
  useFetchOrdersData,
  useOrderDeleteMutation,
  useOrderSyncMutation,
  useOrderUpdateMutation,
} from "../../../apis/orderApis";
import ActionSidebar from "./ActionSidebar";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { OrderFormData } from "../../../types/types";
import useDebounce from "../../../utilities/useDebounce";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import MessageModal from "../../../components/MessageModal";
import RoleToggle from "../../../components/RoleToggle";
import NoDataFound from "../../../components/common/NoDataFound";
import OrderBulkResponseModals from "./OrderBulkResponseModals";
import OrderBulkUploadModals from "./OrderBulkUploadModals";
import EntriesSelector from "../../../components/common/EntriesSelector";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import { usePermission } from "../../../hooks/usePermissionTabs";
import { T, useLanguage } from "../../../context/LanguageContext";

type Props = {
  pending?: boolean;
};

export default function AllOrders({ pending }: Props) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { allowed: canCreateOrder } = usePermission("orders", "create");
  const { allowed: canUpdateOrder } = usePermission("orders", "update");

  const [showModal, setShowModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showActionSidebar, setShowActionSidebar] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const showRightPanel =
    showModal || showBulkModal || showFilter || showActionSidebar;
  const toggleFilter = () => {
    setShowModal(false);
    setShowBulkModal(false);
    setShowActionSidebar(false);
    setShowFilter((prev) => !prev);
  };

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isReverseOrderWiseOpen, setIsReverseOrderWiseOpen] = useState(false);
  const [isRevertOrder, setIsRevertOrder] = useState(false);
  const [isSmsOpen, setIsSmsOpen] = useState(false);
  const [isForword3PlOpen, setIsForword3PlOpen] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [order, setOrder] = useState<any>();
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(20);
  const debouncedSearchFor = useDebounce(searchFor, 550);

  const [selectedTag, setSelectedTag] = useState<string>("All");

  const tabs = ["Orders"];

  const [activeTab, setActiveTab] = useState<string>("Orders");

  useEffect(() => {
    localStorage.setItem("orderTabActiveRole", activeTab);
  }, [activeTab]);

  useEffect(() => {
    setSearchFor("");
    setPageNo(1);
  }, [activeTab]);

  const profile = useSelector((state: any) => state.auth.profile);
  const clientType = useMemo(() => {
    const access = profile?.access;
    if (access) {
      const upperAccess = access.toUpperCase();
      if (upperAccess === "FM") return "FM";
      if (upperAccess === "LM") return "LM";
      return "BOTH";
    }
    const raw = profile?.clientType;
    if (!raw) return "BOTH";
    const upper = raw.toUpperCase();
    if (upper === "FM") return "FM";
    if (upper === "LM") return "LM";
    return "BOTH";
  }, [profile?.access, profile?.clientType]);

  const isDeletedView = activeTab === "Deleted";
  const [selectedOrders, setSelectedOrders] = useState<any[]>([]);

  const [columns, setColumns] = useState([
    { id: 1, text: "S/N", value: "sn", isShow: false },
    { id: 2, text: "TAG", value: "tag", isShow: true },
    { id: 3, text: "DATE & TIME", value: "createdDate", isShow: true },
    { id: 4, text: "PLATFORM", value: "platform", isShow: true },
    { id: 5, text: "AWB / REF", value: "awbRef", isShow: true },
    { id: 6, text: "WAREHOUSE", value: "warehouse", isShow: true },
    { id: 7, text: "ROUTE", value: "route", isShow: true },
    {
      id: 8,
      text: "3PL SHIPPING",
      value: "shippingDetails",
      isShow: true,
    },
    { id: 9, text: "ORIGIN", value: "origin", isShow: true },
    { id: 10, text: "DESTINATION", value: "destination", isShow: true },
    { id: 11, text: "ADDRESS", value: "address", isShow: true },
    { id: 12, text: "RECEIVER", value: "receiverDetails", isShow: true },
    { id: 13, text: "PAYMENT", value: "paymentInfo", isShow: true },
    { id: 14, text: "MERCHANT", value: "merchant", isShow: true },
    { id: 15, text: "PRODUCTS", value: "actions", isShow: true },
    { id: 16, text: "STATUS", value: "status", isShow: true },
  ]);

  const [defaultVisibleColumns, setDefaultVisibleColumns] = useState<string[]>(
    [],
  );
  useEffect(() => {
    if (columns.length > 0 && defaultVisibleColumns.length === 0) {
      const visible = columns
        .filter((col) => col.isShow)
        .map((col) => col.value);
      setDefaultVisibleColumns(visible);
    }
  }, [columns]);

  const handleSetHeadings = (value: string | undefined, checked: boolean) => {
    setColumns((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };

  useEffect(() => {
    if (defaultVisibleColumns.length > 0) {
      setColumns((prev) =>
        prev.map((col) => ({
          ...col,
          isShow: defaultVisibleColumns.includes(col.value),
        })),
      );
    }
  }, [defaultVisibleColumns]);

  const openForword3PlModal = (orderData?: any) => {
    if (orderData) setOrder(orderData);
    setIsForword3PlOpen(true);
  };
  const closeForword3PlModal = () => setIsForword3PlOpen(false);
  const openSmsModal = () => setIsSmsOpen(true);
  const closeSmsModal = () => setIsSmsOpen(false);
  const openEditModal = (data: any) => {
    setOrder(data);
    setIsEditOpen(true);
  };

  const [orderItemId, setOrderItemId] = useState<any>(null);
  const [openResponse, SetOpenResponse] = useState<boolean | string>(false);
  const [orderBulkResponse, setOrderBulkResponse] = useState<any>(null);
  const closeEditModal = () => setIsEditOpen(false);

  const { mutate: deleteMutate, isPending: isDeletePending } =
    useOrderDeleteMutation(order?.id ?? "");
  const { mutate: syncMutate, isPending: isRouteSyncing } =
    useOrderSyncMutation();
  const { mutate: updateMutate, isPending: isUpdatePending } =
    useOrderUpdateMutation(order?.id ?? "");

  const {
    register,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    handleSubmit,
  } = useForm<OrderFormData>();

  const [filters, setFilters] = useState<any[]>([]);

  const activeFilters = useMemo(() => {
    const combined = [...filters];
    const hasFilterKey = (key: string) =>
      combined.some((f: any) => Object.keys(f)[0] === key);

    if (selectedTag !== "All" && !hasFilterKey("orderType")) {
      combined.push({ orderType: selectedTag });
    }
    return combined;
  }, [selectedTag, filters]);

  const { isPending: listPending, refetch } = useFetchOrdersData(
    pageNo,
    debouncedSearchFor,
    limit,
    activeFilters,
  );

  const orders = useSelector((state: any) => state.orders.list);

  const {
    data: deletedOrders,
    isPending: deletedOrderslistPending,
    refetch: fetchDeletedOrders,
  } = useFetchDeleteOrdersData(pageNo, debouncedSearchFor);

  const openDeleteModal = (data: any) => {
    setOrder(data);
    setIsDeleteOpen(true);
  };
  const openRevertModal = (data: any) => {
    setOrder(data);
    setIsRevertOrder(true);
  };

  useEffect(() => {
    if (isDeletedView) {
      fetchDeletedOrders();
    } else {
      refetch();
    }
  }, [
    debouncedSearchFor,
    pageNo,
    limit,
    activeFilters,
    fetchDeletedOrders,
    refetch,
  ]);

  const handleSelectOrder = (order: any) => {
    setSelectedOrders((prev) => {
      const exists = prev.some((o) => o.id === order.id);
      if (exists) return prev.filter((o) => o.id !== order.id);
      return [...prev, order];
    });
  };

  const handleLabelPrint = (shipment: any) => {
    setOrder(shipment);
    setShowLabelModal(true);
  };

  const syncOrder = () => {
    syncMutate(undefined, {
      onSuccess: () => {
        toast.success(t("Orders synced successfully!"));
        refetch();
      },
      onError: (err: any) => {
        toast.error(err?.message || t("Failed to sync orders"));
      },
    });
  };

  const deleteOrder = () => {
    deleteMutate(undefined, {
      onSuccess: () => {
        setIsDeleteOpen(false);
        refetch();
        toast.success(t("Order deleted successfully"));
      },
      onError: (error: any) => {
        toast.error(error?.message || t("Failed to delete order"));
      },
    });
  };

  const handleUpdateOrder = (formData: any) => {
    updateMutate(formData, {
      onSuccess: () => {
        setIsEditOpen(false);
        refetch();
        toast.success(t("Order updated successfully"));
      },
      onError: (error: any) => {
        toast.error(error?.message || t("Failed to update order"));
      },
    });
  };

  const handleDownloadXLSX = () => {
    const ordersList = isDeletedTab ? deletedOrders?.orders : orders?.orders;
    const dataToExport =
      selectedOrders.length > 0 ? selectedOrders : ordersList || [];

    if (!dataToExport.length) {
      toast.error(t("No orders to export"));
      return;
    }

    const data = dataToExport.map((row: any, idx: number) => {
      return {
        "S/N": idx + 1,
        Tag: row.orderType || "LM",
        Date: new Date(row.createdAt).toLocaleDateString(),
        Platform: row.platform || "-",
        "AWB Number": row.awbNumber,
        Reference: row.referenceNumber,
        Warehouse: row.warehouseName,
        Route: row.routeCode || row.route_code || "",
        "Shipping Company": row.shippingCompany || "",
        "Shipping AWB": row.shippingAwbNumber || "",
        Origin: row.senderCityName || "",
        "Destination City": row.receiverCityName || "",
        "Destination Country": row.receiverCountryName || "",
        "Destination District": row.receiverDistrictName || "",
        "Receiver Name": row.receiverName || "",
        "Receiver Mobile": row.receiverMobile || "",
        "Payment Type": row.paymentType || "",
        "COD Amount": row.codAmount || 0,
        Status: row.status || "",
      };
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    XLSX.writeFile(wb, "orders_export.xlsx");
    toast.success(t("Exported successfully!"));
  };

  const goToPage = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setPageNo(page);
    setSelectedOrders([]);
  };

  const renderPageNumbers = () => {
    const pages: (number | "...")[] = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (pageNo > 3) pages.push("...");
      for (
        let i = Math.max(2, pageNo - 1);
        i <= Math.min(totalPages - 1, pageNo + 1);
        i++
      ) {
        pages.push(i);
      }
      if (pageNo < totalPages - 2) pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };

  const filterChips = useMemo(() => {
    const chips: Array<{
      heading: string;
      value: string;
      key: string;
      displayValue: string;
    }> = [];

    const FILTER_LABEL_MAP: Record<string, string> = {
      awbNumber: "Search",
      seller: "Seller",
      warehouseName: "Warehouse",
      paymentType: "Payment Type",
      codAmount: "COD Amount",
      sameDate: "Same Date",
      entryDate: "Entry Date",
      closeDate: "Close Date",
      senderCityName: "Origin City",
      senderCountryName: "Origin Country",
      receiverCityName: "Destination City",
      receiverCountryName: "Destination Country",
      receiverDistrictName: "Destination District",
      city: "City",
      serviceType: "Order Type",
      platform: "Platform",
      shippingCompany: "Shipping Company",
      shippingAwbNumber: "Shipping AWB",
    };

    filters.forEach((filter: any) => {
      const [key, value] = Object.entries(filter)[0] || [];
      if (key && value) {
        const label = FILTER_LABEL_MAP[key] || key;
        chips.push({
          heading: label,
          value: value as string,
          key,
          displayValue: value as string,
        });
      }
    });

    return chips;
  }, [filters]);

  const handleRemoveChip = (key: string, value: string) => {
    setFilters((prev) =>
      prev.filter((f) => {
        const [filterKey, filterValue] = Object.entries(f)[0];
        return !(filterKey === key && filterValue === value);
      }),
    );
  };

  const handleResetAll = () => {
    setFilters([]);
  };

  const handleResetFilters = () => {
    setSelectedTag("All");
    setFilters([]);
    setSearchFor("");
    setShowSearch(false);
    setSelectedOrders([]);
    setPageNo(1);
    toast.success(t("Filters reset successfully"));
  };

  const hasActiveFilters =
    searchFor !== "" || selectedTag !== "All" || filters.length > 0;

  const isDeletedTab = activeTab === "Deleted";
  const dataSource = isDeletedTab ? deletedOrders : orders;
  const isLoading = isDeletedTab ? deletedOrderslistPending : listPending;
  const totalPages = dataSource?.totalPages ?? 1;
  const totalOrdersCount =
    dataSource?.totalOrders ?? dataSource?.orders?.length ?? 0;

  return (
    <div className="w-full flex flex-col">
      {/* ── Top Header Row (Tabs on Left + Total Selected Card on Top-Right) ── */}
      <div className="flex items-center justify-between w-full px-0 mb-2 z-10">
        <RoleToggle
          options={tabs}
          active={activeTab}
          onChange={setActiveTab}
          containerClassName="inline-flex items-center gap-2.5 rounded-lg bg-gradient-to-b from-white/20 to-white/60 backdrop-blur-xl transition-all duration-300 py-1 px-1.5 overflow-x-auto hide-scrollbar max-w-full shadow-inner border border-gray-300"
          activeClassName="bg-black text-white font-bold shadow-sm"
          inactiveClassName="bg-transparent text-[#212121]/70 font-semibold hover:text-[#212121]"
        />

        <OrderSummaryStats
          selectedCount={selectedOrders.length}
          totalCount={totalOrdersCount}
        />
      </div>

      {/* Applied Filters Chips if active */}
      {filterChips.length > 0 && (
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center flex-wrap gap-2">
            <p className="text-[#212121] text-base font-medium">
              {t("Applied Filter :")}{" "}
            </p>
            {filterChips.map((chip, i) => (
              <div
                key={i}
                className="flex items-center gap-2 px-3 py-1.5 bg-[#F7F6F2] rounded-full text-xs font-medium text-[#212121]"
              >
                <b>{chip.heading} :</b> {chip.displayValue}
                <span
                  onClick={() => handleRemoveChip(chip.key, chip.value)}
                  className="bg-[#212121]/5 hover:bg-[#212121]/20 rounded-full p-1 cursor-pointer transition"
                >
                  <IconX size={14} />
                </span>
              </div>
            ))}
          </div>
          <button
            onClick={handleResetAll}
            className="bg-[#303030] text-white px-4 py-2 text-sm rounded-full flex-shrink-0 hover:bg-[#404040] transition"
          >
            {t("Reset All")}
          </button>
        </div>
      )}

      {/* Main Content card with glassy gradient background */}
      <div className="relative grid grid-cols-12 gap-6 p-2 bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 rounded-lg w-full">
        <div className="absolute inset-0 rounded-lg bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

        {/* Main Table Column */}
        <div
          className={
            showRightPanel
              ? "col-span-12 xl:col-span-7 z-10"
              : "col-span-12 z-10"
          }
        >
          {/* ── Main Card (Header + Table Joined) ─────────────────────── */}
          <div className="border rounded-lg overflow-visible">
            <div className="px-1 py-3.5">
              <div className="flex flex-col lg:flex-row lg:items-center justify-end gap-4">
                {/* Right side: Action controls */}
                <div className="flex items-center flex-wrap gap-2.5">
                  {/* Reset Filters button */}
                  {hasActiveFilters && (
                    <button
                      onClick={handleResetFilters}
                      className="w-8 h-8 flex items-center justify-center border border-slate-200 text-[#212121] rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer disabled:opacity-50"
                      title={t("Reset Filters")}
                    >
                      <IconRotateClockwise size={14} stroke={2.5} />
                    </button>
                  )}

                  {/* FM/LM Shift Filter on the top-right as a square button/dropdown */}
                  <div className="relative group">
                    <DropdownFilter
                      setValue={(val: any) => {
                        const tag = val || "All";
                        setSelectedTag(tag);
                        if (tag !== "FM") {
                          setFilters([]);
                        } else {
                          setShowSearch(false);
                        }
                      }}
                      value={selectedTag === "All" ? "" : selectedTag}
                      filterheadings={[
                        { id: "FM", value: "FM", type: "FM" },
                        { id: "LM", value: "LM", type: "LM" },
                      ]}
                    />
                    <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                      {t("Tag Filter")}
                    </div>
                  </div>

                  {/* Premium Search */}
                  <PremiumSearch
                    value={searchFor}
                    onChange={(e) => {
                      setSearchFor(e.target.value);
                      setPageNo(1);
                    }}
                  />

                  {/* Export */}
                  <div className="relative group">
                    <button
                      onClick={handleDownloadXLSX}
                      className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                    >
                      <IconDownload size={17} stroke={2.5} />
                    </button>
                    <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                      {t("Export to Excel")}
                    </div>
                  </div>

                  {/* Filter Sidebar toggle */}
                  <div className="relative group">
                    <button
                      onClick={toggleFilter}
                      className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all duration-150 border shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer ${
                        showFilter
                          ? "bg-[#FBD037] border-[#FBD037] text-[#131327]"
                          : "bg-white hover:bg-slate-50 border-slate-200 text-slate-700"
                      }`}
                    >
                      <IconAdjustmentsHorizontal size={17} stroke={2} />
                    </button>
                    <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                      {t("Advanced Filters")}
                    </div>
                  </div>

                  {/* Entries Limit Selector */}
                  {dataSource && (
                    <EntriesSelector
                      value={limit}
                      options={[
                        20,
                        ...(totalPages * limit > 20 ? [30] : []),
                        ...(totalPages * limit > 50 ? [50] : []),
                        ...(totalPages * limit > 100 ? [100] : []),
                      ]}
                      onChange={(val) => {
                        setLimit(val);
                        setPageNo(1);
                      }}
                    />
                  )}

                  {/* Columns Hide/Show Filter */}
                  <div className="relative group">
                    <ColumnsFilter
                      columnsData={columns}
                      setHeadings={handleSetHeadings}
                    />
                    <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                      {t("Columns View")}
                    </div>
                  </div>

                  {/* Sync Routes */}
                  {canUpdateOrder && (
                    <ButtonStyled
                      onClick={syncOrder}
                      disabled={isRouteSyncing}
                      isPending={isRouteSyncing}
                      variant="outline"
                      value={t("Sync Routes")}
                    />
                  )}

                  {/* Bulk Actions Button */}
                  {/* {canUpdateOrder && (
                    <ButtonStyled
                      onClick={() => {
                        setShowFilter(false);
                        setShowModal(false);
                        setShowBulkModal(false);
                        setShowActionSidebar((prev) => !prev);
                      }}
                      variant={showActionSidebar ? "solid" : "outline"}
                      value={t("Bulk Actions")}
                    />
                  )} */}

                  {/* New Order Button */}
                  {canCreateOrder && (
                    <ButtonStyled
                      onClick={() => {
                        setShowFilter(false);
                        setShowActionSidebar(false);
                        setShowBulkModal(false);
                        setShowModal((prev) => !prev);
                      }}
                      variant={showModal ? "solid" : "outline"}
                      value={t("New Order")}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* ── Table ────────────────────────────────────────────────── */}
            <div className="border-t border-slate-100">
              {isLoading ? (
                <TableSkeleton
                  columns={columns.filter((c) => c.isShow).map((c) => c.text)}
                  rows={6}
                />
              ) : dataSource && dataSource.orders?.length > 0 ? (
                <AllOrderTable
                  data={dataSource}
                  columnsData={columns}
                  currentPage={pageNo}
                  limitPage={limit}
                  isCheckboxEnabled={true}
                  selectedOrders={selectedOrders}
                  onSelectOrder={handleSelectOrder}
                  onViewDetails={(awb) => navigate(`/orders/${awb}`)}
                  showRightPanel={showRightPanel}
                />
              ) : (
                <NoDataFound
                  title="No orders found matching the filter"
                  message="Try adjusting your filters or search keywords."
                />
              )}
            </div>
          </div>
        </div>

        {/* ── Sidebar Right Panel ────────────────────────────────────────── */}
        {showRightPanel && (
          <>
            {/* Backdrop on mobile */}
            {/* <div
              className="fixed inset-0 bg-black/40 z-30 xl:hidden"
              onClick={() => {
                setShowModal(false);
                setShowBulkModal(false);
                setShowFilter(false);
                setShowActionSidebar(false);
              }}
            /> */}
            <div className="col-span-12 xl:col-span-5  ">
              {showFilter ? (
                <FilterSidebar
                  setFilters={setFilters}
                  refetch={isDeletedView ? fetchDeletedOrders : refetch}
                  onClose={toggleFilter}
                />
              ) : showActionSidebar ? (
                <ActionSidebar
                  onClose={() => setShowActionSidebar(false)}
                  selectedOrders={selectedOrders}
                  setSelectedOrders={setSelectedOrders}
                  orders={dataSource?.orders || []}
                  refetch={refetch}
                  onShowBulkResponse={(res) => {
                    setOrderBulkResponse(res);
                    SetOpenResponse(true);
                  }}
                />
              ) : (
                <div className="relative border rounded-lg border-gray-200 flex flex-col bg-transparent overflow-hidden">
                  <div className="flex items-center justify-between px-6 py-6 shrink-0 bg-transparent border-b border-gray-200 mb-3 pb-3">
                    <div className="flex items-center gap-2">
                      <h2 className="text-lg font-bold text-[#212121]">
                        <T>Create Order</T>
                      </h2>
                      <div className="flex items-center gap-2">
                        <ButtonStyled
                          onClick={() => {
                            if (showBulkModal) {
                              setShowBulkModal(false);
                              setShowModal(true);
                            } else {
                              setShowBulkModal(true);
                              setShowModal(false);
                            }
                          }}
                          variant={showBulkModal ? "solid" : "outline"}
                          value={t("Bulk Order")}
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      {showBulkModal && (
                        <ButtonStyled
                          type="button"
                          onClick={() => {
                            const submitBtn = document.getElementById(
                              "order-bulk-submit-btn",
                            );
                            if (submitBtn) {
                              submitBtn.click();
                            }
                          }}
                          variant="solid"
                          value={t("Submit")}
                        />
                      )}
                      <button
                        type="button"
                        onClick={() => {
                          setShowModal(false);
                          setShowBulkModal(false);
                        }}
                        className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-700 bg-white"
                        title={t("Close")}
                      >
                        <IconX size={18} />
                      </button>
                    </div>
                  </div>
                  <div className="max-h-[calc(100vh-20rem)] overflow-y-auto overflow-hidden">
                    {showModal && (
                      <AddOrdersModals
                        onClose={() => setShowModal(false)}
                        fetchData={refetch}
                        isSidebar
                      />
                    )}
                    {showBulkModal && (
                      <OrderBulkUploadModals
                        onClose={() => {
                          setShowBulkModal(false);
                          refetch();
                        }}
                        onResponseOpene={() => SetOpenResponse(true)}
                        setOrderBulkResponse={setOrderBulkResponse}
                        isSidebar
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {/* ── Pagination ───────────────────────────────────────────── */}
        {totalPages > 1 && (
          <div className="flex items-center justify-end px-2 col-span-12 z-10">
            <div className="flex items-center gap-1">
              <button
                onClick={() => goToPage(pageNo - 1)}
                disabled={pageNo === 1}
                className="flex items-center justify-center w-8 h-8 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 disabled:opacity-30 disabled:cursor-not-allowed transition shadow-sm"
              >
                <IconChevronLeft size={14} stroke={2.5} />
              </button>
              {renderPageNumbers().map((p, i) =>
                p === "..." ? (
                  <span
                    key={`ellipsis-${i}`}
                    className="w-8 h-8 flex items-center justify-center text-xs text-slate-400 font-bold"
                  >
                    …
                  </span>
                ) : (
                  <button
                    key={p}
                    onClick={() => goToPage(p as number)}
                    className={`w-8 h-8 flex items-center justify-center rounded-lg border text-xs font-bold transition shadow-sm ${
                      pageNo === p
                        ? "bg-[#FBD037] border-[#FBD037] text-[#131327]"
                        : "bg-white border-slate-200 text-slate-600 hover:bg-slate-50"
                    }`}
                  >
                    {p}
                  </button>
                ),
              )}
              <button
                onClick={() => goToPage(pageNo + 1)}
                disabled={pageNo === totalPages}
                className="flex items-center justify-center w-8 h-8 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 disabled:opacity-30 disabled:cursor-not-allowed transition shadow-sm"
              >
                <IconChevronRight size={14} stroke={2.5} />
              </button>
            </div>
          </div>
        )}

        {/* Modals */}
        {isEditOpen && (
          <EditOrderModal
            open={isEditOpen}
            onClose={closeEditModal}
            order={order}
            register={register}
            errors={errors}
            setValue={setValue}
            watch={watch}
            clearErrors={clearErrors}
            handleSubmit={handleSubmit(handleUpdateOrder)}
            isPending={isUpdatePending}
          />
        )}

        {isDeleteOpen && (
          <DeleteModal
            open={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            deleteOrder={deleteOrder}
            isDeletePending={isDeletePending}
            register={register}
            errors={errors}
          />
        )}

        {isReverseOrderWiseOpen && (
          <ReverseOrderWiseModal
            open={isReverseOrderWiseOpen}
            onClose={() => setIsReverseOrderWiseOpen(false)}
          />
        )}

        {isForword3PlOpen && (
          <Forword3PlModal
            open={isForword3PlOpen}
            onClose={closeForword3PlModal}
          />
        )}

        {showLabelModal && (
          <LabelPrintModal
            open={showLabelModal}
            onClose={() => setShowLabelModal(false)}
            order={order}
          />
        )}

        {isSmsOpen && <SmsModal open={isSmsOpen} onClose={closeSmsModal} />}
      </div>
    </div>
  );
}
